import { axios } from '../libraries'

const api = axios.create({
  baseURL: 'http://fevci.id/pehjGSZ/QtKOwrD/api'
})

export default api
